import React from 'react';
import PropTypes from 'prop-types';
import * as rights from '../../../../model/rights';
import GenericRow from './GenericRow';

class SiteRow extends GenericRow {
  constructor(props) {
    super(props);
  }

  render() {
    return <div className={'row col-md-12'}>
      <div className={'col-md-4'} style={{marginTop: '12px'}}>
        <div style={this.getColumnStyle()}>
          <span>SITE</span>
        </div>
      </div>
      <div className={'col-md-8'}>
        {this.getTableDataContent(rights.SITE_READ_PRIVILEGE)}
        {this.getTableDataContent(rights.SITE_ADD_PRIVILEGE)}
        {this.getTableDataContent(rights.SITE_EDIT_PRIVILEGE)}
        {this.getEmptyDataContent()}
        {this.getTableDataContent(rights.SITE_DISABLE_PRIVILEGE)}
        {this.getTableDataContent(rights.SITE_ASSIGN_WKC_PRIVILEGE)}
      </div>
    </div>;
  }
}

SiteRow.propTypes = {
  permissionSection: PropTypes.object,
  onChange: PropTypes.func,
};

export default SiteRow;
